<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form>
        <v-row>
          <v-col>
            <h2 class="pb-5">
              {{ this.pageTitle }}
              <span class="page_title_value">{{ this.pageTitleValue }}</span>
            </h2>
          </v-col>
        </v-row>
        <v-row><v-col cols="4" sm="10" class="pb-5 mt-n10 ml-n3"><v-subheader class="blue--text">{{$t('clockdata.defaultsettings')}}</v-subheader></v-col></v-row>
        <v-row>
          <v-col col="12" sm="12" class="pb4-4 mt-n8">
            <app-table 
            v-bind:parentObject = "{
               tabHeader: this.tabHeader,
               detailItem: this.formData.detail
              }"
              v-on:input="addItemHandler"
            />
          </v-col>
        </v-row>

        <v-row><v-col cols="4" sm="10" class="pb-5 mt-n8 ml-n3"><v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader></v-col></v-row>
        <v-row>
          <v-col cols="5" sm="5" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.fromdate')"
              type="date"
              ref="startdate"
              :rules="[rules.required]"
              v-model="formData.startdate"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="5" sm="5" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('columns.todate')"
              type="date"
              ref="enddate"
              :rules="[rules.required]"
              v-model="formData.enddate"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" class="pb-n5 mt-n8">
            <v-btn
              color="#6ACB9A"
              style="width: 100px; color: white"
              v-on:click="saveHandler()"
              >{{$t('button.save')}}</v-btn
            >
            <v-btn
              color="#1278D7"
              style="width: 100px; margin-left: 10px; color: white"
              v-on:click="processHandler()"
              >{{$t('button.process')}}</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import ErrorDialogue from "../../../components/common/ErrorDialog";
import moment from "moment";
import Loading from "vue-loading-overlay";
import CRUDTable from '../../../components/attendance/clockdata/CRUDTable';


export default {
  components: {
    "app-error": ErrorDialogue,
    Loading,
    'app-table': CRUDTable,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        requiredRouding: (value) => !!value || this.$t('reportsparam.required'),
      },
      roundinglist: [
        { text: this.$t('processclockdatarecord.donotround'), value: "do not round" },
        { text: this.$t('processclockdatarecord.rounddown'), value: "round down" },
        { text: this.$t('processclockdatarecord.roundup'), value: "round up" },
      ],
      pageTitle: this.$t('processclockdata'),
      pageTitleValue: "",
      formData: {
        detail: [],
        startdate: moment().format("YYYY-MM-DD"),
        enddate: moment().format("YYYY-MM-DD"),
        userid: this.$store.getters.userId,
      },
      tabHeader: [
          { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
          { text: this.$t('columns.company'), value: 'compnyname', width: '200px', sortable: false },
          { text: this.$t('processclockdatarecord.otrounding'), value: 'roundingdesc', width: '200px', sortable: false },
          { text: this.$t('processclockdatarecord.minutes'), value: 'roundto', width: '200px', sortable: false },
      ],
      logiclist: [],
      logic: [],
      errMsg: "",
      isErr: false,
      editMode: false,
      loading: false,
    };
  },

  methods: {
    addItemHandler($event) {
      this.formData.detail =$event
    },
    updateValue() {
            this.$emit('input', {
                detail: this.formData.detail,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                search: this.formData.search,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
            
    },
    saveHandler() {
      const vm = this;
      vm.updateValue();
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.loading = true;
      this.$store.dispatch('post', {url: "/clockdatalogic", payload: this.formData})
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          if (res.data.status == 201) {
            // vm.loadDetailHandler();
            this.$dialog
              .alert("Default settings saved");
          } else {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          this.loading = false;
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
    processHandler() {
      const vm = this;
      if (!vm.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      console.log(vm.formData);

      this.loading = true;
      this.$store.dispatch('post', {url: "/importclockdata/process", payload: this.formData})
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          if (res.data.status == 201) {
            this.$dialog
              .alert(this.$t('piarabrpl'))
              .then((dialog) => {
                console.log(dialog);
              });
            // this.$router.push({
            //   name: "processclockdatalog",
            //   params: {
            //     staffcount: res.data.res.staffcount,
            //     processed: res.data.res.processed,
            //     uploaded: res.data.res.uploaded,
            //   },
            // });
          } else {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          this.loading = false;
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
    loadDetailHandler() {
      const vm = this;
      this.$store.dispatch('get', {url: "/clockdatalogic/all"})
        .then(function (res) {
          for (let i = 0; i < res.data.rec.length; i++) {
            vm.formData.detail.push({
              overridepending: res.data.rec[i].overridepending,
              overrideall: res.data.rec[i].overrideall,
              companyid: res.data.rec[i].companyid,
              compnyname:res.data.rec[i].compnyname,
              compnycode: res.data.rec[i].compnycode,
              roundingid: res.data.rec[i].roundingid,
              roundingcode: res.data.rec[i].roundingcode,
              roundingdesc: res.data.rec[i].roundingdesc,
              roundto: res.data.rec[i].roundto,
              rectimestamp: res.data.rec[i].rectimestamp,
              updatedby: res.data.rec[i].updatedby,
              action:1 ,
              stamp: res.data.rec[i].stamp,
            });
          }
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },
    loadLogicHandler() {
      const vm = this;
      this.$store.dispatch('get', {url: "/processclockdata/getfileformat"})
        .then(function (res) {
          vm.logic = res.data.rec;
          for (let i = 0; i < res.data.rec.length; i++) {
            vm.logiclist.push({
              text: res.data.rec[i].logicname,
              value: res.data.rec[i].id,
            });
          }
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },
    ChangeLogic(id) {
      let item = this.logic.find((item) => item.id === id);
      this.formData.logicid = item.id;
      this.formData.logiccode = item.logiccode;
    },
  },
  mounted() {
    this.loadDetailHandler();
  },
};
</script>
